import * as mutationTypes from '@/store/mutation-types.js'
import store from '@/store/index.js'
let instance = null // singleton

export default class ConfigFileService {
  constructor () {
    if (!instance) {
      instance = this
    }

    this.writeFile = function (tekst) {
      localStorage.setItem('listOfConnections', JSON.stringify(tekst))
    }

    this.readFile = function () {
      CONNECTIES = localStorage.getItem('listOfConnections')
      CONNECTIES = CONNECTIES === null ? [] : JSON.parse(CONNECTIES)
      store.commit(mutationTypes.PUSH_FILE_CONNECTIONS_TO_LIST_OF_CONNECTIONS, CONNECTIES)
    }

    this.removeFile = function () {
      localStorage.clear()
    }
  }
}
